export const CART_ADD_ITEM = 'CART_ADD_ITEM'

export const CART_REMOVE_ITEM = 'CART_REMOVE_ITEM'

export const CART_SAVE_SHIPPING_ADDRESS = 'CART_SAVE_SHIPPING_ADDRESS'

export const CART_SAVE_SALES_PROGRAM = 'CART_SAVE_SALES_PROGRAM'

export const CART_SAVE_SALES_PROGRAM_GROUP = 'CART_SAVE_SALES_PROGRAM_GROUP'

export const CART_CLEAR_ITEMS = 'CART_CLEAR_ITEMS'

export const CART_SAVE_ADJUSTMENTS = 'CART_SAVE_ADJUSTMENTS'

export const CART_SAVE_CONFIGURE = 'CART_SAVE_CONFIGURE'

export const CART_SAVE_CLIENTINFO = 'CART_SAVE_CLIENTINFO'

export const CART_SAVE_QUOTE = 'CART_SAVE_QUOTE'
